import { Bone, Skeleton } from '@tkww/orion-web-ds-feedback';
import React from 'react';
import Styles from './VendorListSkeleton.scss';

interface VendorListSkeletonProps {
	items: number;
	height?: number;
}

export const VendorListSkeleton = ({
	items,
	height,
}: VendorListSkeletonProps) => (
	<div className={Styles.skeletonContainer} style={{ height }}>
		{Array.from({ length: items }).map((_, index) => (
			// biome-ignore lint/suspicious/noArrayIndexKey: Not need a unique key for skeletons
			<Skeleton key={`skeleton-${index}`} className={Styles.skeletonCard}>
				<Bone className={Styles.boneImage} />
				<div className={Styles.detailsColumn}>
					<Bone className={Styles.boneTitle} />
					<Bone className={Styles.boneDescription} />
					<Bone className={Styles.boneMeta} />
					<Bone className={Styles.bonePill} />
				</div>
			</Skeleton>
		))}
	</div>
);
